/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssignableTeam } from './assignableTeam';
import { UserMinimal } from './userMinimal';


/**
 * Response schema of the `assignable` action — used for OpenAPI only, never for output.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AssignableUsers { 
    teams: Array<AssignableTeam>;
    users: Array<UserMinimal>;
}
export const AssignableUsers_teams_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AssignableUsers_users_Validators: ValidatorFn[] =
    [  Validators.required, ];


